

export const ContactPresentation = () => {
  return (
    <div className="contact-presentation">
        <img src="../assets/contact.png" alt="contact" className="contact-presentation-image" />
    </div>
  )
}
